/* eslint-disable import/prefer-default-export */
import get from 'lodash/fp/get';

import { showSnackbar } from '../main/views/app';

export const dispatchErrors = ({ dispatch, errorHandler, responsePayload, customMessage }) => {
  const errors = get(['data', 'errors'], responsePayload);
  dispatch && errorHandler && dispatch(errorHandler({ errors }));
  const globalError = get('GLOBAL', errors);
  if (dispatch) {
    if (globalError && globalError.messageKey) {
      dispatch(showSnackbar({ message: globalError.messageKey }));
    } else {
      dispatch(showSnackbar({ message: customMessage || 'error.generic' }));
    }
  }
};
